module.exports = __webpack_public_path__ + "media/images/category/rank_t_bg-a4a8b67186317fd78a31d70fd3ef3a98.gif";